export const FlareDataVoidTags: string[] = [
  // void tags for '.flcts' file
  'ConditionTag',
  // void tags for '.fltar' file
  'PDF',
  'DocumentProperties',
  'PrintedOutput',
  'Elasticsearch',
  'Glossary', // Glossaries > Glossary
  'RelationshipTable', // RelationshipTables > RelationshipTable
  'meta', // MetaTagList > meta
  'file', // MicroContentSearch > FeaturedSnippets|KnowledgePanel > microContentSubset > file
  'metaTag', // MicroContentSearch > FeaturedSnippets|KnowledgePanel > microContentSubset > metaTag
];
